// Filename : views/calendar-week.js
define('views/modules/calendar/calendar/calendar-component/calendar-week',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Views
    'views/modules/calendar/calendar/calendar-component/calendar-day',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // Views
    VCalendarDay
) {

    var VCalendarWeek = Backbone.View.extend({
        dayView: VCalendarDay,
        tagName: "tr",
        className: "week",

        initialize: function(opt) {
            this.options = opt || {};
            this.setUrl("root", opt.url);
        },

        render: function() {
            this.$el.empty();
            this.removeChildViews();
            this.addAll();
            return this;
        },

        addAll: function() {
            var dayNameList = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
            var dayCount = 0;
            var container = document.createDocumentFragment();
            this.collection.each(function(model) {
                if (dayCount >= 7) dayCount = 0;
                model.dayName = dayNameList[dayCount];
                container.appendChild(this.addDay(model, false).el);
                dayCount++;
            }, this);
            this.$el.append(container);
        },

        addDay: function(model, render) {
            var view = new this.dayView(_.extend({
                model: model,
                url: this.url.root,
                role: this.options.role
            }, _.result(this, 'dayOptions', false)));

            this.childViews.push(view);
            view.render();
            if (render !== false) {
                this.$el.append(view.el);
            }

            return view;
        }

    });

    return VCalendarWeek;

});

